
import { defineComponent } from 'vue'
import MedicalRecords from '../components/records/MedicalRecords.vue'

export default defineComponent({
  name: 'RecordView',
  components: { MedicalRecords }
})
